import React, {useEffect, useState} from "react";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import {useDebounce} from "@uidotdev/usehooks";
import {
    RaikoChipTypes,
    RaikoCustomSimpleChip, RaikoCustomTable,
    RaikoGridOneColumn, RaikoMaterialOutlinedInput, RaikoTableSearchContainer, RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";

const ChooseResidenceFromTheList = ({periodId, selectNewResidence}) => {

    let page = 0
    let size = 15

    const service = new PeriodService()


    const [isLoading, setIsLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0);
    const [residenceListInfo, setResidenceListInfo] = useState([])
    const [residenceListData, setResidenceListData] = useState([]);
    const [numberOfItems, setNumberOfItems] = useState(0);

    const [title, setTitle] = useState("");
    const filterTitle = useDebounce(title, 500)

    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
        }
    }, [filterTitle]);

    function getDataFromServer() {
        setIsLoading(true)

        service.getActiveHostsList(
            periodId,
            filterTitle,
            page,
            size
        ).then(response => {
            setPageCount(response.totalPage)
            setNumberOfItems(response.numberOfItems)
            setResidenceListData([])

            response.data.map((item, index) => {
                setResidenceListData(prevState => [
                    ...prevState,
                    preparingChooseResidenceFromTheListRow(
                        (page * size) + index + 1,
                        item.id,
                        item.priority,
                        item.residence.metaData.title,
                        item.clerk && item.clerk.metaData ? item.clerk.metaData.fullName : "-",
                        item.clerk && item.clerk.phoneNumber ? item.clerk.phoneNumber : "-",
                        item.menCapacity,
                        item.womenCapacity,
                        item.activeForAcceptation,
                        item.activeForAutomaticAcceptance,
                    )
                ])
            })
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    function preparingChooseResidenceFromTheListRow(
        number,
        id,
        priority,
        title,
        servant,
        phoneNumber,
        menNumber,
        womenNumber,
        total,
        acceptanceStatus,
        automaticCheck,) {
        return {
            number,
            id,
            priority,
            title,
            servant,
            phoneNumber: phoneNumber,
            menNumber,
            womenNumber,
            total,
            acceptanceStatus: acceptanceStatus ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            automaticCheck: automaticCheck ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,

        }

    }


    function handleSelectItem(rowId) {
        if (selectNewResidence) {
            for (let i = 0; i < residenceListData.length; i++) {
                if (residenceListData[i].id === rowId) {
                    selectNewResidence(residenceListData[i]);
                    break;
                }
            }
        }
    }

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    return (
        <>
            <RaikoGridOneColumn>
                {/*<RaikoMaterialOutlinedInput*/}
                {/*    labelText={"جست و جو"}*/}
                {/*    className="flex-grow-1"*/}
                {/*    spellCheck={false}*/}
                {/*    InputProps={{*/}
                {/*        startAdornment: (*/}
                {/*            <InputAdornment position="start">*/}
                {/*                <div className={"search-icon"}/>*/}
                {/*            </InputAdornment>*/}
                {/*        ),*/}
                {/*    }}*/}
                {/*    placeHolder={"عبارت مورد نظر خود را وارد نمایید."}*/}
                {/*    value={title}*/}
                {/*    setValue={setTitle}*/}
                {/*/>*/}
                <RaikoTableSearchContainer
                    labelText={"جست و جو"}
                    placeHolder={"عبارت مورد نظر خود را وارد نمایید."}
                    value={title}
                    setValue={setTitle}/>
                <RaikoTableTitleContainer
                    title={"اقامتگاه ها"}
                    amount={numberOfItems}
                />
                <RaikoCustomTable
                    isLoading={isLoading}
                    data={residenceListData}
                    header={tableHeader}
                    rowClicked={handleSelectItem}
                    handlePaginationChange={handlePagination}
                    pageCount={pageCount}
                />
            </RaikoGridOneColumn>
        </>
    )
}
export default ChooseResidenceFromTheList;
const tableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "priority",
        label: "اولویت"
    },
    {
        id: "title",
        label: "عنوان",
    },
    {
        id: "servant",
        label: "خادم",
    },
    {
        id: "phoneNumber",
        label: "شماره تماس"
    },
    {
        id: "menNumber",
        label: "تعداد آقا",
    },
    {
        id: "womenNumber",
        label: "تعداد خانم",
    },
    /*{
        id: "total",
        label: "ظرفیت کل",
    },*/
    /*{
        id: "acceptanceStatus",
        label: "وضعیت پذیرش",
    },
    {
        id: "automaticCheck",
        label: "بررسی خودکار"
    },*/

]